var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-7911031c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "section py-16 bg-gray-50 relative" };
var _hoisted_2 = { class: "container" };
var _hoisted_3 = { class: "flex flex-col items-center" };
var _hoisted_4 = ["textContent"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = { class: "mt-10 grid grid-rows gap-5 max-w-4xl m-auto" };
var _hoisted_7 = { class: "flex items-center" };
var _hoisted_8 = { class: "flex-grow mr-5" };
var _hoisted_9 = { class: "text-2xl font-semibold" };
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = {
    key: 0,
    class: "shrink"
};
var _hoisted_12 = {
    key: 0,
    class: "mt-10 list-none grid grid-rows gap-6"
};
var _hoisted_13 = { class: "mt-10 flex justify-center" };
import { useLandingBlock } from '@student/components/Landing/Course/Blocks/useLandingBlock';
import { computed, getCurrentInstance } from 'vue';
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CourseProgram',
    props: {
        landingBlock: {}
    },
    emits: ["register"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var _b = useLandingBlock(function () { return props.landingBlock; }), landingBlock = _b.landingBlock, orderAction = _b.orderAction, parseTextWithUrl = _b.parseTextWithUrl;
        var t = useI18n().t;
        var stepsPrepared = computed(function () {
            return __spreadArray([], __read(landingBlock.value.program), false).map(function (c) {
                if (Array.isArray(landingBlock.value.description)) {
                    landingBlock.value.description = {};
                }
                if (!landingBlock.value.description[c.id]) {
                    landingBlock.value.description[c.id] = '';
                }
                c.description = landingBlock.value.description[c.id];
                c.showLessons = false;
                return c;
            });
        });
        var getLessonIcon = function (type) {
            switch (type) {
                case 'default':
                    return 'graduation-cap-bold';
                case 'test':
                    return 'test-bold';
                case 'homework':
                    return 'task-bold';
                case 'webinar':
                    return 'webinar';
                default:
                    return '';
            }
        };
        var showLessonsToggle = function (card) {
            var _a, _b;
            card['showLessons'] = !card.showLessons;
            (_b = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy) === null || _b === void 0 ? void 0 : _b.$forceUpdate();
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h2", {
                            class: "max-w-lg text-3xl md:text-5xl font-medium text-center",
                            textContent: _toDisplayString(_unref(landingBlock).title || 'Программа курса')
                        }, null, 8, _hoisted_4),
                        (_unref(landingBlock).subtitle)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "mt-4 max-w-lg text-lg font-medium text-center",
                                innerHTML: _unref(parseTextWithUrl)(_unref(landingBlock).subtitle)
                            }, null, 8, _hoisted_5))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepsPrepared.value, function (step) {
                            return (_openBlock(), _createElementBlock("div", {
                                key: step.id,
                                class: "bg-white rounded-lg shadow border border-gray-200 box-border py-7 px-5 sm:px-10"
                            }, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("h3", _hoisted_9, _toDisplayString(step.name), 1),
                                        (step.description)
                                            ? (_openBlock(), _createElementBlock("p", {
                                                key: 0,
                                                class: "card__description mt-3 text-xl opacity-50",
                                                innerHTML: _unref(parseTextWithUrl)(step.description)
                                            }, null, 8, _hoisted_10))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (step.lessons && step.lessons.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            (step.showLessons)
                                                ? (_openBlock(), _createBlock(_component_e_icon, {
                                                    key: 0,
                                                    class: "w-12 h-12 text-gray-200 cursor-pointer",
                                                    icon: "arrow-up-round-fill",
                                                    onClick: function ($event) { return (showLessonsToggle(step)); }
                                                }, null, 8, ["onClick"]))
                                                : (_openBlock(), _createBlock(_component_e_icon, {
                                                    key: 1,
                                                    class: "w-12 h-12 text-primary cursor-pointer",
                                                    icon: "arrow-down-round-fill",
                                                    onClick: function ($event) { return (showLessonsToggle(step)); }
                                                }, null, 8, ["onClick"]))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                (step.showLessons && step.lessons && step.lessons.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.lessons, function (lesson) {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: lesson.id,
                                                class: "flex"
                                            }, [
                                                _createVNode(_component_e_icon, {
                                                    icon: getLessonIcon(lesson.type),
                                                    class: "w-6 h-6 text-primary mr-5 flex-none"
                                                }, null, 8, ["icon"]),
                                                _createElementVNode("p", null, _toDisplayString(lesson.name), 1)
                                            ]));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_e_button, {
                        size: "large",
                        onClick: _unref(orderAction)
                    }, {
                        default: _withCtx(function () { return [
                            _createTextVNode(_toDisplayString(_unref(t)('button.signUpNow')), 1)
                        ]; }),
                        _: 1
                    }, 8, ["onClick"])
                ])
            ]));
        };
    }
});
